import { Component, OnInit } from "@angular/core";
import {
  changeLanguageLink,
  isOnShell,
} from "@villemontreal/shell-portal-client-lib";
import { environment } from "../environments/environment";
import { isEnglish } from "./social-housing-calculator/current-language";
import { fromEvent } from "rxjs";
import { take } from "rxjs/operators";
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  title = "social-housing-web";
  ngOnInit(): void {
    this._trySetLanguageLinks();
  }

  private _trySetLanguageLinks() {
    if (!isOnShell()) {
      return;
    }

    const link = !isEnglish()
      ? `/${environment.pathEn}/`
      : `/${environment.pathFr}/`;
    fromEvent(document, "DOMContentLoaded")
      .pipe(take(1))
      .subscribe(() => changeLanguageLink(link));
  }
}
